import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getPlayerPaymentHistoryReport } from "../../../services/ReportService";
import { formatDateToApi } from "../../../utils/dateUtils";

const PaymentModeModal = ({ show, onHide, startDate, endDate }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show, startDate, endDate]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const fromDate = formatDateToApi(startDate);
      const toDate = formatDateToApi(endDate);
      const res = await getPlayerPaymentHistoryReport(
        0,
        10,
        "",
        "",
        "",
        "",
        fromDate,
        toDate
      );
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview payment mode data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/player-payment-collection-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-credit-card text-success me-2"></i>
          Mode & Payments - Recent Transactions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="success" />
            <p className="mt-2 text-muted">Loading payment transactions...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Player Name</th>
                  <th>Mobile</th>
                  <th>Package</th>
                  <th>Payment Mode</th>
                  <th>Amount</th>
                  <th>Invoice No.</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">
                        {item?.player?.name || item?.name || "-"}
                      </td>
                      <td>{item?.player?.phone || item?.phone || "-"}</td>
                      <td>
                        {item?.subscription?.packageType?.name ||
                          item?.playerSubscription?.packageType?.name ||
                          item?.package?.name ||
                          item?.packageType ||
                          "-"}
                      </td>
                      <td>
                        <span className="badge badge-sm badge-outline-primary">
                          {item?.paymentMode || item?.paymentType || "Online / Cash"}
                        </span>
                      </td>
                      <td className="fw-bold text-success">
                        ₹ {item?.amount ?? item?.amountPaid ?? item?.price ?? 0}
                      </td>
                      <td>{item?.invoiceNumber || item?.transactionId || "-"}</td>
                      <td>
                        <span className="badge badge-sm badge-success">
                          {item?.player?.status || item?.paymentStatus || item?.status || "Paid"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center py-4 text-muted">
                      No transaction records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModeModal;

